import { useCallback, useEffect } from 'react';

const useKeyDown = ({ target, key }, callBack) => {
  const handleKeyDown = useCallback(
    (event) => {
      const downKey = event.key;
      if (!key) return callBack(event);
      if (downKey === key) return callBack(event);
    },
    [callBack, key]
  );

  useEffect(() => {
    if (!target) return;

    const targetDom = target;

    // dom is focusin, the keydown event valid
    if (!targetDom.hasAttribute('tabIndex')) targetDom.setAttribute('tabIndex', -1);
    targetDom.style.outline = 'none';
    targetDom.focus && targetDom.focus();
    targetDom.addEventListener && targetDom.addEventListener('keydown', handleKeyDown);

    return () => {
      targetDom.removeEventListener && targetDom.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown, target]);
};

export default useKeyDown;
